import {Moment} from 'moment-timezone';
import * as Dates from '../Dates';
import HourlyForecastItem from './HourlyForecastItem';

export default class HourlyForecastDate {
  date: Moment;
  timezone: string;
  itemList: HourlyForecastItem[];

  constructor(date: Moment, timezone: string) {
    this.timezone = timezone;
    this.date = date;
    this.itemList = [];
  }

  getDate() {
    return this.date;
  }

  formatDay() {
    return Dates.formatDate(this.getDate().unix(), this.timezone, 'dddd');
  }

  formatDate() {
    return Dates.formatDate(this.getDate().unix(), this.timezone, 'LL');
  }

  addItem(item: HourlyForecastItem) {
    this.itemList.push(item);
  }

  getItemList(): HourlyForecastItem[] {
    return this.itemList;
  }

  getStrippedItemList() {
    return this.itemList.filter(
      (item: HourlyForecastItem) =>
        Dates.differenceWithNow(item.getTimestamp(), 'hour') >= 0,
    );
  }
}
